/* global Modernizr */

import { Controller } from 'stimulus';
import lightbox from 'lightbox2';

const BREAKPOINT = 992;

class LightboxController extends Controller {
  connect() {
    lightbox.option({
      albumLabel: this.data.get('label'),
      positionFromTop: Modernizr.mq(`(min-width: ${BREAKPOINT}px)`) ? 200 : 50,
    });
  }
}

LightboxController.targets = [
  //
];

export default LightboxController;
